import React from "react";

const WalletCreationIcon = ({ size, color }) => {
  return (
    <svg
      width={size || "43.33px"}
      height={size || "43.33px"}
      viewBox="0 0 52 52"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.9999 47.6667C37.9661 47.6667 47.6666 37.9662 47.6666 26C47.6666 14.0339 37.9661 4.33337 25.9999 4.33337C14.0337 4.33337 4.33325 14.0339 4.33325 26C4.33325 37.9662 14.0337 47.6667 25.9999 47.6667Z"
        stroke="#C4C4C4"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26 17.3334V34.6667"
        stroke="#00008B"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.3333 26H34.6666"
        stroke="#00008B"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default WalletCreationIcon;
